import { render, staticRenderFns } from "./GpTab.vue?vue&type=template&id=6dce1994&scoped=true&"
import script from "./GpTab.vue?vue&type=script&lang=js&"
export * from "./GpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce1994",
  null
  
)

export default component.exports